<template>
    <div class="col-md-5">
        <div class="checkoutBlock" :class="(inProgress?'processing':'')">
            <div v-if="cartToken">
                <h4>Your Order</h4>
                <div class="progressor"></div>
                <ul v-if="items.length">
                    <li v-for="item in items" v-bind:key="item.id" class="row">
                        <div class="col-8 col-xs-8">
                            x{{ item.quantity }} {{ item.product.name }}
                        </div>
                        <div class="col-4 col-xs-4">
                            {{ item.total | formatMoney('') }}
                        </div>
                        <div v-if="item.varText" class="col-12 col-xs-12">
                            <div v-html="item.varText" class="variant" />
                        </div>
                        <div class="col-12 col-xs-12 controls">
                            <button class="btn btn-primary btn-circle btn-circle-sm m-1" @click="update(item.id,(item.quantity-1))"><i class="fa fa-minus"></i></button>
                            <button class="btn btn-primary btn-circle btn-circle-sm m-1" @click="update(item.id,(item.quantity+1))"><i class="fa fa-plus"></i></button>
                            <button class="btn btn-primary btn-circle btn-circle-sm pull-right" @click="update(item.id,0)"><i class="fa fa-trash"></i></button>
                        </div>
                    </li>
                </ul>
                <div v-else class="empty">Empty</div>
                <div class="progressor"></div>
                <div class="total row">
                    <div class="col-8 col-xs-8">
                        Total:
                    </div>
                    <div class="col-4 col-xs-4">
                        {{ total | formatMoney('') }}
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="head">Your order is empty</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'OrderSummary',
        props: {
            width: String
        },
        computed: {
            cartToken () {
                return this.$store.state.token
            },
            items () {
                return this.$store.state.cart.items
            },
            total () {
                return this.$store.state.cart.totals.total
            },
            inProgress () {
                return this.$store.state.inProgress
            },
            totalItems () {
                let total = 0
                for(let i=0; i<this.$store.state.cart.items.length; i++) {
                    total += this.$store.state.cart.items[i].quantity
                }
                return total
            }
        },
        mounted() {
            this.$store.dispatch('tryToRecover')
        },
        methods: {
            update (item, quantity) {
                this.$store.dispatch('updateItem', [item, quantity])
            },
            checkout () {
                this.$store.dispatch('tryToRecover')
                this.$root.$emit('send', 'checkout')
            }
        }
    }
</script>